var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityLargePrint = function SvgAccessibilityLargePrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.976 24.684c-.264 0-.388-.106-.51-.353l-.864-1.91H4.328l-.864 1.91a.53.53 0 0 1-.511.353H1.419a.311.311 0 0 1-.3-.455l5.485-11.872a.32.32 0 0 1 .299-.194h.176a.3.3 0 0 1 .3.194l4.29 9.373"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m8.737 20.47-1.763-3.88H6.92l-1.728 3.88zm2.043 3.505 8.49-18.359a.49.49 0 0 1 .454-.3h.273a.465.465 0 0 1 .463.3l8.402 18.359c.164.354-.054.709-.463.709h-2.374c-.409 0-.6-.164-.79-.546l-1.337-2.946H15.74l-1.332 2.946a.82.82 0 0 1-.791.546h-2.373c-.41 0-.628-.355-.464-.71z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m22.565 18.164-2.727-6.001h-.082l-2.674 6.001z"
  }))));
};
export default SvgAccessibilityLargePrint;